"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResponsiveText = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var Text_1 = __importDefault(require("../Text"));
function createResponsiveText(styleConfig) {
    var Responsive = (0, styled_1.default)(Text_1.default)(function (props) {
        var theme = props.theme, query = props.query;
        if (!query)
            return;
        var style = {};
        /**
         * map query to corresponding mediaQueries
         *
         * query:
         * {
         *    _: P4,
         *    md: P1
         * }
         *
         * =>
         *
         * output:
         * {
         *    ...styles_from_P4,
         *    [theme.mediaQueries.md]: {
         *    ...styles_from_P1
         *    }
         * }
         */
        Object.entries(query).forEach(function (entries) {
            var _a;
            var key = entries[0], value = entries[1];
            if (key === '_') {
                style = __assign(__assign({}, style), styleConfig(value, theme));
            }
            else {
                style = __assign(__assign({}, style), (_a = {}, _a[theme.mediaQueries[key]] = __assign({}, styleConfig(value, theme)), _a));
            }
        });
        return style;
    });
    return Responsive;
}
exports.createResponsiveText = createResponsiveText;
